import _ from 'lodash';
import { goto, preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';

import { fetchPendingInvites, toggleMachinesForUser } from 'app/api/account-settings-api';
import { fetchMachinesForUser } from 'app/common/api/common-api';
import {
  fetchSubscriptionUsers,
  addUserAsMember,
  removeUserAsMember,
} from 'app/api/subscriptions';
import UsersAndInvites from 'app/components/settings/users-and-invites';
import * as machineSelectors from 'app/selectors/machines';
import { subscriptions } from 'app/selectors/subscriptions';

import { subscriptionsLoading } from './subscriptions-utils';

const { getStringsForPage, getMarkdownStringsForPage } = contentfulModels;

const mapStateToProps = state => ({
  users: machineSelectors.getSortedAllUsersForCurrentUsersMachines(state),
  pendingInvites: machineSelectors.getPendingInvites(state),
  machines: machineSelectors.getMachineList(state),
  managedMachines: machineSelectors.getManagedMachineList(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
  pageMarkdownStrings: getMarkdownStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
  isLoading: _.get(state, 'common.machinesLoading') || !BROWSER || subscriptionsLoading(state),
  isSubscriptionActive: subscriptions.isActive(state),
  isSubscriber: subscriptions.isSubscriber(state),
  subscriptionUsers: subscriptions.getAddedUsers(state),
});

const mapDispatchToProps = dispatch => ({
  gotoInviteForm: () => dispatch(goto('/settings/users/invite')),
  /**
   * onAccessChangeSubmit handles the submit of the user change access dialog form.
   * It allows you to update an added machine user's machine access, as well as their
   * Subscription added user status.  If you remove a user from all machines you have access to,
   * and they are also an added Subscription user on your account, this will remove that user as
   * an added user on your Subscription.
   */
  onAccessChangeSubmit: (values, initialValues, subscriptionData) => {
    const allMachinesDeselected = _.get(values, 'machines.length', 0) === 0;
    const subscriberChanged = (
      initialValues.subscriber !== values.subscriber
      || allMachinesDeselected
    );
    if (subscriberChanged && !_.isEmpty(subscriptionData.email)) {
      const done = () => (dispatch(fetchSubscriptionUsers()));
      // user must be on your machine to be a subscriber
      // if removed from all machines, will remove them as added user
      const flag = allMachinesDeselected ? false : values.subscriber;
      const { subscription, addedUsers, email } = subscriptionData;
      const addedUser = _.find(addedUsers, u => u.attributes.secondary_user_email === email);
      if (!flag && addedUser) {
        dispatch(removeUserAsMember(subscription.id, addedUser.id, done));
      } else if (flag && !addedUser) {
        dispatch(addUserAsMember(subscription.id, email, done));
      }
    }

    const done = () => {
      dispatch(fetchMachinesForUser());
      dispatch(fetchPendingInvites());
    };

    const initialMachines = initialValues.machines;

    if (!_.isEqual(values.machines, initialMachines)) {
      dispatch(toggleMachinesForUser(values.email, values.machines, initialMachines, done));
    }
  },
});

const UsersContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch, getState }) => {
    const state = getState();
    const promises = [];
    if (!_.get(state, 'common.machinesLoading')) {
      promises.push(dispatch(fetchMachinesForUser()));
    }

    promises.push(dispatch(fetchPendingInvites()));

    return Promise.all(promises);
  }, { client: true, blocking: false })(UsersAndInvites),
);

export default UsersContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/users.js